var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioFile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 52,
    viewBox: "0 0 39 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1919_6633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9999 11.9854V48.0063C38.9999 50.2132 37.0746 52.0001 34.6974 52.0001H8.74931C6.37209 52.0001 4.44678 50.2132 4.44678 48.0063V8.49179C4.44678 6.28487 6.37209 4.49414 8.74931 4.49414H29.8974L38.9999 11.9893V11.9854Z",
    fill: "#D4DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3127 8.25879V44.2758C35.3127 46.4827 33.3874 48.2697 31.0102 48.2697H5.06205C2.68484 48.2697 0.759521 46.4827 0.759521 44.2758V4.76132C0.759521 2.55441 2.68484 0.763672 5.06205 0.763672H26.2102L35.3127 8.25879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0101 49.0333H5.06203C2.27089 49.0333 0 46.8989 0 44.2758V4.76129C0 2.13437 2.27089 0 5.06203 0H26.2101C26.3848 0 26.5557 0.0610911 26.6924 0.171819L35.7949 7.66694C35.9696 7.81203 36.0722 8.02966 36.0722 8.25876V44.2758C36.0722 46.8989 33.8013 49.0333 31.0101 49.0333ZM5.06203 1.52728C3.11013 1.52728 1.51899 2.97819 1.51899 4.76129V44.2758C1.51899 46.0589 3.11013 47.506 5.06203 47.506H31.0101C32.962 47.506 34.5532 46.0589 34.5532 44.2758V8.61767L25.9405 1.52728H5.06203Z",
    fill: "#4365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2063 37.8158C17.9924 37.8158 16.1924 36.006 16.1924 33.78C16.1924 31.554 17.9924 29.7441 20.2063 29.7441C22.4202 29.7441 24.2202 31.554 24.2202 33.78C24.2202 36.006 22.4202 37.8158 20.2063 37.8158ZM20.2063 31.2714C18.8316 31.2714 17.7114 32.3978 17.7114 33.78C17.7114 35.1622 18.8316 36.2885 20.2063 36.2885C21.581 36.2885 22.7012 35.1622 22.7012 33.78C22.7012 32.3978 21.581 31.2714 20.2063 31.2714Z",
    fill: "#4365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4607 34.543C23.0429 34.543 22.7012 34.1994 22.7012 33.7794V19.5986C22.7012 19.1786 23.0429 18.835 23.4607 18.835H27.8012C28.2189 18.835 28.5607 19.1786 28.5607 19.5986C28.5607 20.0186 28.2189 20.3622 27.8012 20.3622H24.2202V33.7794C24.2202 34.1994 23.8784 34.543 23.4607 34.543Z",
    fill: "#4365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1203 21.454H8.27097C7.85325 21.454 7.51147 21.1104 7.51147 20.6904C7.51147 20.2704 7.85325 19.9268 8.27097 19.9268H19.1203C19.5381 19.9268 19.8798 20.2704 19.8798 20.6904C19.8798 21.1104 19.5381 21.454 19.1203 21.454Z",
    fill: "#4365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1203 25.8144H8.27097C7.85325 25.8144 7.51147 25.4707 7.51147 25.0507C7.51147 24.6307 7.85325 24.2871 8.27097 24.2871H19.1203C19.5381 24.2871 19.8798 24.6307 19.8798 25.0507C19.8798 25.4707 19.5381 25.8144 19.1203 25.8144Z",
    fill: "#4365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7798 30.1786H8.27097C7.85325 30.1786 7.51147 29.835 7.51147 29.415C7.51147 28.995 7.85325 28.6514 8.27097 28.6514H14.7798C15.1975 28.6514 15.5393 28.995 15.5393 29.415C15.5393 29.835 15.1975 30.1786 14.7798 30.1786Z",
    fill: "#4365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2102 0.763672V8.22061H35.3127L26.2102 0.763672Z",
    fill: "#D4DBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3127 8.9841H26.2102C25.7925 8.9841 25.4507 8.64046 25.4507 8.22046V0.763527C25.4507 0.469526 25.6178 0.198434 25.8836 0.0724338C26.1494 -0.0535666 26.4608 -0.0153847 26.6887 0.171707L35.7912 7.62864C36.0418 7.83482 36.133 8.17083 36.0266 8.47628C35.9203 8.78174 35.6317 8.9841 35.3127 8.9841ZM26.9697 7.45682H33.1785L26.9697 2.37099V7.45682Z",
    fill: "#4365E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1919_6633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 52,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioFile);
export default __webpack_public_path__ + "static/media/audio-file.db2277b7c1e2561734a428d10e40a2c9.svg";
export { ForwardRef as ReactComponent };